import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet'
import UplyftInfo from './UplyftInfo'


export default function Layout({
    title = "Title",
    htmlTitle,
    className,
    linkBtnDisplay = 'block',
    showPreButton = "visible",
    preRoute = "",
    preRouteClass = "",
    preRouteText = "Back",
    btnContinueText = "Continue",
    showBtnContinue = "visible",
    children,
    invokeFunction
}) {
    const clickSubmit = e => {
        invokeFunction(e);
    };

    const controlButtons = () => (
        <div className='container d-flex justify-content-between pt-5 '>
            <Link to={`/onboarding/syndicator/${preRoute}`} style={{ visibility: `${showPreButton}` }} className={`${preRouteClass} display mr-2`}>
                {preRouteText}
            </Link>
            <button type='submit' className='btn btn-primary display' style={{ visibility: `${showBtnContinue}` }}>
                {btnContinueText}
            </button>
        </div>
    );
    return (
        <>
            <Helmet>
                <title>{`Uplyft Capital Onboarding Syndicator | ${htmlTitle}`}</title>
            </Helmet>
            <main id='syndicatorLayout' >
                <section className='container content layoutFading'>

                    <div className={className}>
                        <div className='container text-center display'>
                            <h1 style={{ color: '#000000' }}>Syndication</h1>
                            <h2>We’d love to hear from you.</h2>
                        </div>
                        <div className='mt-5 p-3 display'></div>

                        <form noValidate onSubmit={(e) => clickSubmit(e)} className='pt-5-lg'>
                            <div>
                                <h2 className='pb-3'> {title} </h2>
                            </div>
                            <div className='shadow p-5 mb-2 bg-white roundCorners'>
                                {children}
                            </div>
                            {controlButtons()}
                        </form>
                    </div>
                </section>
                <div className='mt-5 container'><UplyftInfo /></div>

            </main>
        </>
    );
}
